/** zh-CN catalogue `ui` (W3-09; English: src/ui/ui.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'ui',
  locale: 'zh-CN',
  messages: {
    close: '关闭',
    mixed: '混合',
    mixedValues: '多个不同的值',
    moreInfo: '更多信息',
    'badge.inUse': '已使用',
    'badge.inUse.tip': '这里使用了在引导模式下隐藏的功能。它仍然有效，也会被导出。',
    'badge.phiraIgnores': 'Phira 忽略',
    'badge.phiraIgnores.tip': 'Phira 不读取此字段。保留它是为了让谱面在 RPE 中仍以相同方式打开。',
    'badge.rpe17': 'RPE ≥ 1.7',
    'badge.rpe17.tip': 'RPE 1.7 引入。旧版 RPE 会忽略它；Phira 支持它。',
    'badge.editorOnly': '仅编辑器',
    'badge.editorOnly.tip': '随项目保存（phiedit.json），永远不会写入谱面。',
    'badge.baked': '导出时烘焙',
    'badge.baked.tip': '导出方式不同：写入谱面时会转换为普通的 RPE 事件。',
    'badge.full': '完整',
    'badge.full.tip': '属于完整模式。在顶栏切换模式即可在各处看到它。',
    'badge.problem.tip': '谱面检查在此处发现了问题。单击打开“问题”。',
    'badge.described': '{label}：{tip}',
    'severity.fatal': '致命',
    'severity.error': '错误',
    'severity.warning': '警告',
    'severity.tip': '提示',
    'info.rpe': 'RPE：{term}',
    'info.community': '社区用语：{term}',
    'illustration.cover': '判定线下方的音符被隐藏',
    'illustration.rotateWithParent': '子线随父线旋转',
    'illustration.side': '音符从判定线的上方或下方落下',
    'illustration.stayThenJump': '数值保持不变，在下一个关键帧处跳变',
    'illustration.easingSlice': '只使用曲线的一部分',
    'illustration.fake': '假键会被绘制，但永远不参与判定',
    'illustration.speed': '流速决定音符接近的快慢',
    'illustration.layers': '各层级相加得到最终数值',
    'number.scrubHint': '拖动以修改。按住 Shift 步长更大，按住 Alt 步长更小。',
    'number.mixedHint': '输入一个值统一设置，或输入表达式，例如 +=10、*-1 或 lerp(-400, 400, u)',
    'number.result': '= {value}',
    'number.random': '随机：应用时每一项各取一个值',
    'number.randomSeed': '随机：每一项各取一个值（种子 {seed}）',
    'number.resultSeed': '= {value}（随机，种子 {seed}）',
    'number.invalid': '请输入数字或表达式',
    'number.unitToggle': '以 {unit} 显示数值',
    'number.unitToggleCurrent': '当前以 {unit} 显示数值。单击改为以 {other} 显示。',
    'beat.hint': '拍数写法如 12:3/4、12 3/4 或 49/4；+1/4 表示移动四分之一拍；23.5s 表示以秒为单位的时间',
    'beat.relative': '将每一项移动 {delta}',
    'beat.rounded': '{echo}（已取整 {ms, number, 0.000} 毫秒）',
    'color.none': '无（默认）',
    'color.pick': '选择颜色',
    'color.presets': '常用颜色',
    'color.hex': '十六进制',
    'color.hexPlaceholder': '#RRGGBB',
    'color.red': '红',
    'color.green': '绿',
    'color.blue': '蓝',
    'color.invalidHex': '请以 #RRGGBB 格式输入颜色，例如 #FF8800',
    'color.channelRange': '请输入 0 到 255 之间的整数',
    'color.system': '更多颜色',
    'color.value': '颜色 {hex}',
    'color.noneValue': '无（默认）',
    'curve.label': '缓动',
    'curve.hold': '钩定（保持后跳变）',
    'curve.linear': '线性',
    'curve.bezier': '自定义曲线（贝塞尔）',
    'curve.tween': '{name}（RPE {id}）',
    'curve.slice': '{name}，使用 {left} 到 {right} 部分',
    'curve.invalid': 'Phira 无法使用曲线的这一部分',
    'splitter.resize': '调整大小',
    'progress.label': '进度',
    'progress.percent': '{value, number, percent}',
    'list.empty': '没有项目',
    'gallery.title': '设计系统',
    'gallery.intro': 'src/ui 中每个基础组件的各种状态，用于视觉和键盘检查。',
    'gallery.theme': '主题',
    'gallery.theme.dark': '深色',
    'gallery.theme.light': '浅色',
    'gallery.theme.highContrast': '高对比度',
    'gallery.language': '语言',
    'gallery.reducedMotion': '减少动画',
    'gallery.buttons': '按钮',
    'gallery.primary': '导出',
    'gallery.secondary': '预览',
    'gallery.ghost': '取消',
    'gallery.danger': '删除判定线',
    'gallery.disabled': '不可用',
    'gallery.disabledReason': '请先选择一个关键帧',
    'gallery.apply': '应用',
    'gallery.play': '播放',
    'gallery.snap': '节拍吸附',
    'gallery.undo': '撤销',
    'gallery.badges': '徽标',
    'gallery.fields': '输入框',
    'gallery.speed': '速度',
    'gallery.speedHelp': '音符移动距离的倍数。',
    'gallery.positionX': 'X',
    'gallery.rotation': '旋转',
    'gallery.opacity': '不透明度',
    'gallery.time': '时间',
    'gallery.noteColour': '音符颜色',
    'gallery.lineColour': '标签颜色',
    'gallery.name': '名称',
    'gallery.namePlaceholder': '判定线名称',
    'gallery.notes': '备注',
    'gallery.json': '原始 JSON',
    'gallery.unitTimes': 'x',
    'gallery.unitPx': 'px',
    'gallery.unitDeg': '度',
    'gallery.unitRaw': '0-255',
    'gallery.unitPercent': '%',
    'gallery.choices': '选项',
    'gallery.side': '方向',
    'gallery.sideTop': '上方',
    'gallery.sideBottom': '下方',
    'gallery.noteType': '类型',
    'gallery.tap': 'Tap',
    'gallery.drag': 'Drag',
    'gallery.flick': 'Flick',
    'gallery.hold': 'Hold',
    'gallery.fake': '假键：不参与判定，没有声音',
    'gallery.mixedCheckbox': '混合选择',
    'gallery.cover': '遮罩（隐藏线下音符）',
    'gallery.coverInfo': '判定线下方的音符在位于线下时不会被绘制。',
    'gallery.coverRpeTerm': 'Cover (isCover)',
    'gallery.coverCommunityTerm': '遮罩',
    'gallery.metronome': '节拍器',
    'gallery.volume': '音量',
    'gallery.overlays': '叠加层',
    'gallery.openDialog': '打开对话框',
    'gallery.dialogTitle': '删除 3 条判定线？',
    'gallery.dialogBody': '这些判定线及其音符将被移除。此操作可以撤销。',
    'gallery.openSheet': '打开侧边面板',
    'gallery.sheetTitle': '分布',
    'gallery.sheetBody': '此面板打开时，时间轴和预览仍可使用。',
    'gallery.popover': '弹出框',
    'gallery.popoverBody': '弹出框用于放置小型表单和选择器。',
    'gallery.tooltip': '悬停或聚焦此处',
    'gallery.tooltipBody': '工具提示会显示其命令的快捷键。',
    'gallery.menu': '菜单',
    'gallery.contextMenu': '在此处右键单击',
    'gallery.copy': '复制',
    'gallery.paste': '粘贴',
    'gallery.more': '更多',
    'gallery.mirror': '镜像',
    'gallery.reverse': '反转',
    'gallery.tabs': '选项卡',
    'gallery.tabLines': '判定线',
    'gallery.tabProblems': '问题',
    'gallery.tabHistory': '历史',
    'gallery.tabContent': '“{tab}”选项卡的内容。',
    'gallery.problemCount': '{count, plural, other {# 个问题}}',
    'gallery.lists': '列表与布局',
    'gallery.listLabel': '判定线',
    'gallery.lineName': '判定线 {index}',
    'gallery.section': '分区',
    'gallery.sectionBody': '单击分区标题按钮可折叠分区。',
    'gallery.toolbar': '工具',
    'gallery.select': '选择',
    'gallery.place': '放置音符',
    'gallery.erase': '橡皮擦',
    'gallery.progress': '正在导出',
    'gallery.empty': '未发现问题',
    'gallery.emptyBody': '每次编辑后都会运行谱面检查。',
    'gallery.emptyAction': '运行谱面检查',
    'gallery.curves': '曲线',
    'gallery.swatches': '色板',
  },
};

export default catalog;
